import React from 'react';
const testimonials = [{
  name: 'Martín Rodríguez',
  age: 32,
  location: 'Buenos Aires',
  text: 'Llevaba meses queriendo lanzar mi tienda de productos artesanales pero me trababa con todo lo técnico. Dominando Shopify me dio la estructura que necesitaba. En 3 semanas ya tenía mi tienda funcionando y mis primeras ventas. Lo mejor fue entender cómo usar IA para acelerar todo el proceso.',
  avatar: 'MR'
}, {
  name: 'Carolina Méndez',
  age: 28,
  location: 'Córdoba',
  text: 'Soy diseñadora y siempre quise vender mis diseños online pero Shopify me parecía un mundo. Las mentorías grupales fueron clave para resolver mis dudas específicas. Ahora tengo mi tienda armada, pagos conectados y campañas corriendo. Súper recomendable para principiantes.',
  avatar: 'CM'
}, {
  name: 'Lucas Fernández',
  age: 35,
  location: 'Rosario',
  text: 'Intenté armar mi negocio online varias veces y siempre abandonaba a mitad de camino. Este programa me dio claridad y un paso a paso concreto. Las plantillas y los prompts de IA me ahorraron semanas de trabajo. Hoy ya estoy generando mis primeros ingresos por internet.',
  avatar: 'LF'
}, {
  name: 'Valentina Castro',
  age: 26,
  location: 'Mendoza',
  text: 'Tenía una marca de accesorios pero vendía solo por Instagram de forma muy desordenada. Dominando Shopify me ayudó a profesionalizar todo: tienda propia, pagos automáticos, anuncios bien configurados. La inversión se pagó sola con las primeras ventas.',
  avatar: 'VC'
}, {
  name: 'Diego Peralta',
  age: 30,
  location: 'La Plata',
  text: 'Como emprendedor principiante, necesitaba algo práctico y sin tanta teoría. Este programa es exactamente eso. Aprendí a crear mi producto, montar la tienda, configurar Meta Ads y usar IA para contenido. Las mentorías en vivo fueron el diferencial para no quedarme trabado.',
  avatar: 'DP'
}];
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-319">
      <div className="max-w-6xl mx-auto" data-id="element-320">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4 text-center" data-id="element-321">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="text-xl text-gray-600 mb-12 text-center" data-id="element-322">
          Personas como vos que querían vender online y lo lograron
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-323">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow" data-id="element-324">
              <div className="flex items-center gap-4 mb-6" data-id="element-325">
                <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-xl" data-id="element-326">
                  {testimonial.avatar}
                </div>
                <div data-id="element-327">
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-328">
                    {testimonial.name}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-329">
                    {testimonial.age} años • {testimonial.location}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-330">
                "{testimonial.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}